import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import { ApplicationState } from 'store'
import * as navBarActions from 'store/modules/navbar/actions'
import useRedux from 'hooks/useRedux'
import { NAVBAR } from 'store/modules/navbar/types'
import CustomSelect from 'components/Select'
import { useEffect } from 'react'

const ModalPausarAssociado = () => {
  const {
    acaoModalPausarAgente,
    modalPausarAgente,
    motivosPausas,
    motivoPausaId,
    statusAgente
  } = useSelector<ApplicationState, NAVBAR>((state) => state.navbar)
  const { dispatch } = useRedux()

  const handleConfirm = () => {
    if (!acaoModalPausarAgente) return

    dispatch(navBarActions.confirmarAcaoPausarAgenteSaga())
  }
  const titulo =
    acaoModalPausarAgente === 'pausar' ? 'Pausar Agente' : 'Despausar Agente'

  const toggleModal = () => {
    dispatch(navBarActions.toggleModalPausarAgente(false))
  }
  function onChange(value: string) {
    dispatch(navBarActions.setMotivoPausaId(value))
  }
  const motivosFormatados = motivosPausas?.map((item) => ({
    ...item,
    nome: `${item.nome} - ${item.tempo / 60}min`
  }))
  const mensagem =
    acaoModalPausarAgente === 'pausar'
      ? 'Selecione o motivo para pausar o agente:'
      : 'Deseja realmente despausar o agente'

  useEffect(() => {
    dispatch(navBarActions.getMotivosPausaSaga())
  }, [dispatch])
  return (
    <Modal isOpen={modalPausarAgente}>
      <ModalHeader toggle={toggleModal}>
        <SimpleTitleCard colorIcon="F7931E">
          <AiOutlineExclamationCircle className="icon" />
          {titulo}
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody>
        <p>{mensagem}</p>
        {!statusAgente.pausado && (
          <>
            <label>Motivo da pausa:</label>
            <CustomSelect
              options={motivosFormatados}
              placeholder="Selecione"
              onChange={(e) => {
                onChange(e)
              }}
              value={motivoPausaId}
              accessorLabel="nome"
              accessorValue="uuid"
            />
          </>
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Row className="d-flex column-gap-20">
          <CustomButton onClick={toggleModal} background="#662D91">
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleConfirm}>Confirmar</CustomButton>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default ModalPausarAssociado
